import { render, staticRenderFns } from "./CollectedReservations.vue?vue&type=template&id=43100f53"
import script from "./CollectedReservations.vue?vue&type=script&lang=js"
export * from "./CollectedReservations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports